import React from "react";
import PropTypes from "prop-types";
import cover_default from "image_default/article_cover_default.svg";
// import LikeAndCommentAction from "../../shared/LikeAndCommentAction";
// import ImageLinkContainer from "../../shared/ImageLinkContainer";
import { formatMD, autoFillImagePath } from "../../utils/local_tools";

class MPublishArticle extends React.PureComponent {
  render() {
    const { path, title, cover_image_url, createdAt } = this.props;
    const src = autoFillImagePath(cover_image_url);

    return (
      <div className="user-show__article">
        <div>
          <a
            className="u-text-limit--two article-mini__title"
            href={path}
            alt="文章"
            >
            {title}
          </a>
          <div className="u-flex article-mini__center">
            {/* <a className="u-text-limit--four article-mini__summary">
              {description}
            </a> */}
          </div>
          <div className="user-show__date">{formatMD(createdAt)}</div>
          {/* <LikeAndCommentAction
            {...this.props}
            className="article-mini__action"
          /> */}
        </div>
        <a className="article-mini__cover" href={path} target="_blank">
          <img src={src} alt={title} />
        </a>
      </div>
    );
  }
}

MPublishArticle.propTypes = {
  path: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  cover_image_url: PropTypes.string,
};

MPublishArticle.defaultProps = {
  cover_image_url: cover_default,
  description: "",
};

export default MPublishArticle;
